<div class="toggle-visible" [style.display]="appIsHidden ? 'none' : 'block'">
    <ng-container *ngIf="{ value: state$ | async } as stateWrapper">
        <ng-container *ngIf="stateWrapper.value as state">
            <div
                [class.container-wrapper]="viewportScaling.enabled"
                [class.supervisor-mode]="supervisorMode"
                [class.online-mode]="state.configuration.tableMode === TableMode.Online"
            >
                <div
                    class="container"
                    #container
                    (window:resize)="scaleContainer($event)"
                    [style.width]="containerWidth"
                    [style.height]="containerHeight"
                >
                    <header>
                        <div class="header-content">
                            @if (state.configuration.gameType && state.roundState.phase !== AppPhase.TableClosed) {
                                <button
                                    class="icon icon-menu"
                                    [class.icon-menu-active]="menuVisible"
                                    (click)="menuVisible = !menuVisible"
                                ></button>

                                <div class="title">
                                    <div class="text-large" i18n>{{ state.configuration.gameType | gameLabel }}</div>
                                    <div class="text-medium">
                                        <ng-container i18n>Connected players</ng-container>: {{ state.playerCount || 0 }} /
                                        <ng-container i18n>Game ID</ng-container>:
                                        {{ state.roundState.roundId ?? '-' }}
                                    </div>
                                </div>
                            }
                        </div>
                        <div class="header-content">
                            @if (state.roundState.phase !== AppPhase.TableClosed || state.worker) {
                                <div class="title title-align-right">
                                    <div i18n class="text-large">
                                        {{ state.worker?.name || 'Login' }}
                                    </div>
                                    <div class="text-medium">{{ time$ | async }}</div>
                                </div>
                                <button
                                    *ngIf="state.worker?.accessLevel === WorkerAccessLevel.Supervisor"
                                    class="icon icon-logout"
                                ></button>
                            }
                        </div>
                    </header>
                    <div class="body">
                        <div *ngIf="menuVisible" (click)="menuVisible = false" class="menu-container">
                            <div class="menu">
                                <div class="layer layer-menu">
                                    <ul>
                                        <li>
                                            <button i18n (click)="menuVisible = false; aboutDialogVisible = true">About game</button>
                                        </li>

                                        @if (languages.length > 0) {
                                            <li i18n class="label">Languages</li>
                                            @for (language of languages; track language.code) {
                                                <li>
                                                    <button class="no-left-bg" (click)="changeLanguage(language.code)">
                                                        <span class="unicode-icon">{{ language.flagSymbol }}</span
                                                        ><span i18n>{{ language.label }} </span>
                                                    </button>
                                                </li>
                                            }
                                        }
                                    </ul>
                                </div>

                                <div class="layer layer-overlay"></div>
                            </div>
                        </div>

                        <div
                            class="main-area"
                            [class.main-area-when-sidebar-open]="
                                state.configuration.tableMode === TableMode.Online &&
                                state.roundState.phase !== AppPhase.WaitingForCroupier &&
                                state.roundState.phase !== AppPhase.TableClosed
                            "
                        >
                            <main>
                                @if (supervisorMode) {
                                    <app-supervisor-panel [message]="'Scan supervisor card to open table'" />
                                }
                                <app-modal *ngIf="aboutDialogVisible" (closeClicked)="aboutDialogVisible = false">
                                    <app-about [backendVersion]="state.configuration.appVersion" [frontendVersion]="version"></app-about>
                                </app-modal>
                                <app-game-selection
                                    *ngIf="selectGameVisible"
                                    [games]="state.games"
                                    [currentGame]="state.configuration.gameType"
                                    (gameSelected)="onGameSelect($event)"
                                    (closeClicked)="selectGameVisible = false"
                                ></app-game-selection>
                                <app-error-panel
                                    *ngIf="state.roundState?.phase === AppPhase.RoundError"
                                    [errorCode]="state.roundState.errorCode"
                                ></app-error-panel>
                                <app-waiting-for-croupier
                                    *ngIf="state.roundState?.phase === AppPhase.WaitingForCroupier"
                                ></app-waiting-for-croupier>
                                <app-waiting-for-players
                                    *ngIf="state.roundState?.phase === AppPhase.WaitingForPlayers"
                                ></app-waiting-for-players>
                                <app-round-voided *ngIf="state.roundState?.phase === AppPhase.RoundVoid"></app-round-voided>
                                <app-shoe-change *ngIf="state.roundState?.phase === AppPhase.ShoeChange"></app-shoe-change>
                                <app-burn-cards
                                    *ngIf="state.roundState?.phase === AppPhase.CardBurn"
                                    [cardValue]="state.shoeChangeState?.card"
                                    [totalToBurnCount]="state.shoeChangeState?.totalToBurnCount ?? 0"
                                    [burnedCardsCount]="state.shoeChangeState?.burnedCount || 0"
                                ></app-burn-cards>
                                <app-new-round-preparation
                                    *ngIf="state.roundState?.phase === AppPhase.NewRoundPreparation"
                                ></app-new-round-preparation>
                                <app-bets-status
                                    *ngIf="state?.roundState?.phase === AppPhase.BetsOpen"
                                    i18n
                                    [initialTimeInSeconds]="
                                        state.roundState.remainingBettingTimeInSeconds ?? state.configuration.bettingWindowInSeconds
                                    "
                                    >Bets are open
                                </app-bets-status>
                                <app-bets-status
                                    *ngIf="state?.roundState?.phase === AppPhase.BetsClosed"
                                    i18n
                                    [animate]="false"
                                    [initialTimeInSeconds]="0"
                                    >Bets are closed
                                </app-bets-status>
                                <app-game-switch
                                    *ngIf="state.configuration.gameType"
                                    [gameType]="state.configuration.gameType"
                                    [tableUpdate]="state.tableUpdate"
                                    [appPhase]="state.roundState.phase"
                                    [subPhase]="state.roundState.subPhase"
                                >
                                    <app-result-change
                                        result-change
                                        *ngIf="resultChangeMode"
                                        (resultChangeConfirmed)="onResultChangeConfirm($event)"
                                        (resultChangeClosed)="resultChangeMode = false"
                                    ></app-result-change>
                                    <app-count-down
                                        count-down
                                        *ngIf="state?.roundState?.phase === AppPhase.Decision"
                                        [initialTimeInSeconds]="state.configuration.decisionTimeInSeconds ?? 0"
                                        [animate]="true"
                                    ></app-count-down>
                                </app-game-switch>

                                @if (dealerService.gameInProgress) {
                                    <app-cut-card *ngIf="state.shoeChangeState?.cutCardDrawn"></app-cut-card>
                                }
                            </main>

                            <app-notification
                                *ngIf="notification.show"
                                [text]="notification.text"
                                [severity]="notification.severity"
                                [canClose]="notification.canClose"
                                (closeClicked)="hideNotification()"
                            ></app-notification>

                            <footer
                                [class.footer-fixed]="!dealerService.gameInProgress"
                                *ngIf="
                                    !resultChangeMode &&
                                    state.roundState?.phase !== AppPhase.WaitingForPlayers &&
                                    state.roundState?.phase !== AppPhase.RoundVoid
                                "
                            >
                                <div class="buttons-container">
                                    @if (supervisorMode) {
                                        <div class="button-group">
                                            <button
                                                i18n
                                                [disabled]="!dealerService.gameInProgress"
                                                class="button-game button-game-small button-small-padding"
                                                #voidButtonAndChangeShoe
                                            >
                                                Void game and change shoe
                                            </button>

                                            <button
                                                i18n
                                                [disabled]="!dealerService.gameInProgress"
                                                class="button-game button-game-small button-small-padding"
                                                (click)="onVoidClick(voidButton)"
                                                #voidButton
                                            >
                                                Void game
                                            </button>
                                        </div>
                                        <button
                                            i18n
                                            [disabled]="!dealerService.gameInProgressNoRoundEnd"
                                            class="button-game button-game-small"
                                            (click)="resultChangeMode = true"
                                        >
                                            Change result
                                        </button>
                                        <div class="button-group">
                                            <button i18n class="button-game button-game-small">Change game</button>

                                            <button
                                                i18n
                                                [disabled]="
                                                    state.flagsState.tableClosingRequested ||
                                                    !(
                                                        state.roundState.phase !== AppPhase.WaitingForCroupier &&
                                                        state.roundState.phase !== AppPhase.CardBurn
                                                    )
                                                "
                                                class="button-game button-game-small"
                                                [class.button-game-highlight]="state.flagsState.tableClosingRequested"
                                                (click)="onCloseTableClick(closeTableButton)"
                                                #closeTableButton
                                            >
                                                Close table
                                            </button>
                                        </div>
                                    } @else if (state.worker?.accessLevel === WorkerAccessLevel.Croupier) {
                                        <button
                                            i18n
                                            class="button-game button-game-medium"
                                            (click)="onCallSupervisorClick(callSupervisorButton)"
                                            #callSupervisorButton
                                        >
                                            Call supervisor
                                        </button>

                                        <button
                                            *ngIf="state.roundState?.phase === AppPhase.ShoeChange"
                                            i18n
                                            class="button-game button-game-medium button-special"
                                            (click)="onShoeChangedClick(shoeChangedButton)"
                                            appAutofocus
                                            #shoeChangedButton
                                        >
                                            Confirm
                                        </button>

                                        <button
                                            *ngIf="state.flagsState.tableClosingRequested"
                                            i18n
                                            class="button-game button-game-medium"
                                            [class.button-game-selected]="state.flagsState.tableClosingRequested"
                                        >
                                            Closing table
                                        </button>
                                    }
                                </div>
                            </footer>
                        </div>
                        <div
                            class="sidebar"
                            *ngIf="
                                state.configuration.tableMode === TableMode.Online && state.roundState.phase !== AppPhase.WaitingForCroupier
                            "
                        >
                            <app-streaming-video
                                [videoEnabled]="!isVideoHidden"
                                [streamId]="state.configuration.videoStreamId"
                                (toggleClicked)="isVideoHidden = !isVideoHidden"
                            ></app-streaming-video>

                            <app-chat
                                [chatEnabled]="state.flagsState.chatEnabled"
                                [messages]="state.chatMessages"
                                (toggleClicked)="state.flagsState.chatEnabled ? onDisableChatClick($event) : onEnableChatClick($event)"
                            ></app-chat>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
        <div *ngIf="!stateWrapper.value" class="container">
            <h2 i18n class="title-vertical-center title-white">Connecting to table…</h2>
        </div>
    </ng-container>
</div>
